export default __webpack_public_path__ + "static/media/logo.d77aec2e.svg";